<template>
    <div>
        <div v-if="isSysAdmin">
            <v-col cols="12" class="tabs">
                <h2 class="mt-4">{{ t('patients::title.all_samples_and_results') }}</h2>
                <v-tabs v-model="tab" show-arrows>
                    <v-tab v-for="(item, index) in items" :key="index">
                        <div class="tab">
                            {{ item }}
                        </div>
                    </v-tab>

                    <v-tab-item v-for="(item, index) in items" :key="item + index">
                        <blood-result-data-table
                            ref="grid"
                            :initial-filters="initialFilters"
                            :hidden-columns="hiddenColumns"
                            :list-route="listRoute"
                            :columns="columns"
                            :un-assigned-grid="unAssignedGrid"
                            :grid-title="item"
                            :tab="tab"
                        ></blood-result-data-table>
                    </v-tab-item>
                </v-tabs>
            </v-col>
        </div>
        <div v-else>
            <v-col cols="12">
                <h2 class="mt-4 mb-0">{{ t('patients::title.all_samples_and_results') }}</h2>
                <blood-result-data-table
                    ref="grid"
                    :initial-filters="initialFilters"
                    :hidden-columns="hiddenColumns"
                    :list-route="listRoute"
                    :columns="columns"
                    :un-assigned-grid="unAssignedGrid"
                ></blood-result-data-table>
            </v-col>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tab: null,
            items: [
                t('patients::tabs.title.assigned_samples_results'),
                t('patients::tabs.title.unassigned_samples_results'),
            ],
            initialFilters: {
                rejected: null,
                provider_id: null,
                operator: null,
                dispensable: null,
                color_result: null,
            },
            columnsList: {
                assignedColumns: [
                    {
                        text: t('default::grid.label.id'),
                        value: 'id',
                        sortable: false,
                        width: 170,
                    },
                    {
                        text: t('patients::grid.label.blood_result'),
                        value: 'color_result',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.patient'),
                        value: 'patient.name',
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.platelets'),
                        value: 'platelets',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.white_blood_count'),
                        value: 'white_blood_count',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.neutrophils'),
                        value: 'neutrophils',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.dms_id'),
                        value: 'patient.dms_id',
                        width: 140,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.nhs_id'),
                        value: 'patient.nhs_id',
                        width: 140,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.entered_by'),
                        value: 'entered_by',
                        width: 180,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.date_taken'),
                        value: 'date_taken',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('patients::grid.label.date_received'),
                        value: 'date_received',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('patients::grid.label.pharmacy_site'),
                        value: 'pharmacy_site_name',
                        width: 180,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.blood_result_provider'),
                        value: 'provider_name',
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.operator_name'),
                        value: 'operator_name',
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: t('patients::grid.label.blood_status'),
                        value: 'rejected',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.health_status'),
                        value: 'patient.health_status',
                        width: 200,
                        sortable: false,
                    },
                    {
                        text: t('astm-devices::grid.label.actions'),
                        value: 'actions',
                        sortable: false,
                        fields: 'patient.id,editable,dispensable,next_due_date,validity_date,dispensing_days_suggested,dispensing_days_accumulated,is_abnormal',
                        align: 'end',
                        width: 220,
                    },
                ],
                unAssignedColumns: [
                    {
                        text: t('default::grid.label.id'),
                        value: 'id',
                        sortable: false,
                        width: 170,
                    },
                    {
                        text: t('patients::grid.label.blood_result'),
                        value: 'color_result',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.sample_id'),
                        value: 'sample_ref',
                        width: 200,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.pharmacy_site'),
                        value: 'pharmacy_site_name',
                        width: 140,
                        sortable: true,
                    },
                    {
                        text: t('patients::grid.label.date_taken'),
                        value: 'date_taken',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('patients::grid.label.date_received'),
                        value: 'date_received',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('patients::grid.label.blood_result_provider'),
                        value: 'blood_result_provider.name',
                        sortable: true,
                        width: 200,
                    },
                    {
                        text: t('patients::grid.label.entered_by'),
                        value: 'entered_by',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('astm-devices::grid.label.actions'),
                        value: 'actions',
                        sortable: false,
                        width: 220,
                        fields: 'pharmacy_site_id,editable',
                        align: 'end',
                    },
                ],
            },
            hiddenColumnsList: {
                assignedHiddenColumns: ['id'],
                unAssignedHiddenColumns: ['id'],
            },
            hiddenColumns: [],
            columns: [],
            unAssignedGrid: false,
        };
    },
    computed: {
        isSysAdmin() {
            return this.$store.state.user.profile && this.$store.state.user.profile.role === 'sys-admin';
        },
    },
    watch: {
        tab: function (val) {
            this.$store.dispatch('data_table/changeTab', val);
            this.initialFilters.assigned = val === 1 ? 0 : 1;
            this.columns = val === 1 ? this.columnsList.unAssignedColumns : this.columnsList.assignedColumns;
            this.hiddenColumns =
                val === 1
                    ? this.hiddenColumnsList.unAssignedHiddenColumns
                    : this.hiddenColumnsList.assignedHiddenColumns;
            this.unAssignedGrid = val === 1 ? true : false;
            _.delay(() => {
                window.dispatchEvent(new Event('scroll'));
                if (this.$refs.grid[val]) {
                    this.$refs.grid[val].changeTab();
                }
            }, 200);
        },
    },
    created() {
        this.columns = !this.tab ? this.columnsList.assignedColumns : this.columnsList.unAssignedColumns;
        this.hiddenColumns = !this.tab
            ? this.hiddenColumnsList.assignedHiddenColumns
            : this.hiddenColumnsList.unAssignedHiddenColumns;

        this.initialFilters.assigned = 1;
        const urlParams = new URLSearchParams(window.location.search);
        const operator = urlParams.get('operator');
        if (operator) {
            this.initialFilters.operator = parseInt(operator);
        }
    },
};
</script>

<style></style>
